import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { sagaErrorConst } from '../../../constants';
import { EventApis } from '../../_api/events/EventApiServices';
import { createEvent, patchEventStatusType, updateEvents } from '../../actions/actionType/events/EventActionTypes';
import {
  UpdateEventFailures,
  UpdateEventSuccessfull,
  clearEvents,
  createEventFailure,
  createEventStart,
  createEventSuccessfull
} from '../../actions/sagaActions/events/CreateEventSagaActions';
import { CreateEventFailurePayload, CreateEventRequest, PatchEventStatusRequest, UpdateEventRequest } from '../../actions/types/events/CreateEventTypes';

/**
 * Saga to create new event
 * @param requestObject:IEventRequestModel
 */
export function* createEvents({ requestObject }: CreateEventRequest) {
  yield put(clearEvents());
  yield put(createEventStart());
  try {
    const { responseBody: data, isError, error } = yield call(EventApis.callCreateEventApi, requestObject);

    if (isError) {
      throw error;
    }

    if (data.eventName) {
      yield put(createEventSuccessfull(data));
    } else {
      const createEventErrorMessage = sagaErrorConst.createEventMessage;
      throw new Error(createEventErrorMessage);
    }
  } catch (error) {
    const obj: CreateEventFailurePayload = {
      error: String(error)
    };
    yield put(createEventFailure(obj));
  }
}

/**
 * Saga to update event
 * @param requestObject:IEventRequestModel
 */
export function* updateEvent({ requestObject, version }: UpdateEventRequest) {
  yield put(clearEvents());
  yield put(createEventStart());
  try {
    const { responseBody: data, isError, error } = yield call(EventApis.callUpdateEventApi, requestObject, version);

    if (isError) {
      throw error;
    }

    if (data.eventName) {
      yield put(UpdateEventSuccessfull(data));
    } else {
      const createEventErrorMessage = sagaErrorConst.createEventMessage;
      throw new Error(createEventErrorMessage);
    }
  } catch (error) {
    const obj: CreateEventFailurePayload = {
      error: String(error)
    };
    yield put(UpdateEventFailures(obj));
  }
}

/**
 * Saga to patch event status
 * @param requestObject:IPatchStatusModel
 */
export function* patchEventStatus({ requestObject, eventName, version }: PatchEventStatusRequest) {
  yield put(clearEvents());
  yield put(createEventStart());
  try {
    const { responseBody: data, isError, error } = yield call(EventApis.callPatchStatusEventApi, requestObject, eventName, version);

    if (isError) {
      throw error;
    }

    if (data.eventName) {
      yield put(UpdateEventSuccessfull(data));
    } else {
      const createEventErrorMessage = sagaErrorConst.patchEventMessage;
      throw new Error(createEventErrorMessage);
    }
  } catch (error) {
    const obj: CreateEventFailurePayload = {
      error: String(error)
    };
    yield put(UpdateEventFailures(obj));
  }
}

/**
 * Saga Effect to consider latest request
 */
export function* createNewEvent() {
  yield takeLatest(createEvent.CREATE_EVENT_REQUEST, createEvents);
}

/**
 * Saga Effect to consider latest request to update event
 */
export function* updateExistingEvent() {
  yield takeLatest(updateEvents.UPDATE_EVENT_REQUEST, updateEvent);
}

export function* clearEventDetails() {
  yield put(clearEvents());
}

/**
 * Saga Effect to consider latest request to update event status
 */
export function* patchExistingEvent() {
  yield takeLatest(patchEventStatusType.PATCH_EVENT_STATUS_REQUEST, patchEventStatus);
}

/**
 * Clear Event Details
 */
export function* clearEventDetailsSaga() {
  yield takeLatest(createEvent.CLEAR_EVENT_DETAILS, clearEventDetails);
}

export const createEventSaga = [fork(createNewEvent)];
export const updateEventSaga = [fork(updateExistingEvent)];
export const clearEventSaga = [fork(clearEventDetailsSaga)];
export const patchEventSaga = [fork(patchExistingEvent)];
